import React from 'react';
import { toast } from 'react-toastify';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams, Link, useNavigate } from "react-router-dom"
import { ContentHeader, Loader } from '@components';
import { getClientById } from '@app/services/client';
import handleStatus from '../../utils/ajax'
import { logoutUser } from '@app/store/reducers/auth';
import { getAllProjectNames } from '@app/services/project';

const ProjectLink = ({ project }) => {
    if (project.projectName === undefined) {
        return "N/A";
    }

    else {
        return (<Link to={"/view-project/" + project._id}>{project.projectName + "  "}</Link>)
    }


}


const ViewClient = () => {

    const [allProjects, setAllProjects] = useState([])
    const [selectedClientData, setSelectedClientData] = useState({})
    const [showLoader, setShowLoader] = useState(false);
    const [selectedClientProject, setSelectedClientProject] = useState([])
    const params = useParams()
    const { id } = params
    localStorage.setItem("clientId", id)
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const viewClientById = async () => {
        setShowLoader(true);
        const response = await getClientById();
        handleStatus(response.status, () => dispatch(logoutUser()), navigate);
        handleStatus(response.status)
        const result = await getAllProjectNames();
        handleStatus(result.status, () => dispatch(logoutUser()), navigate);

        if (response.data.ok === true) {
            setShowLoader(false);
            if (response.data.data) {
                setSelectedClientData(response.data.data)
                setSelectedClientProject(response.data.data.project)
                setAllProjects(result.data.data)

            }
        }





    }
    useEffect(() => {
        viewClientById();
    }, [])


    if (showLoader) {
        return (<Loader title={"Daily"} />)
    }


    return (
        <div>
            <ContentHeader title="View Clients" path="/all-clients" />
            <section className="content">
                <div className="container-fluid">
                    <div className="card">
                        <div className="card-header">
                            <h3 className="card-title">All about Clients</h3>
                        </div>
                        <div className="card-body">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-header d-flex align-items-baseline">
                                        <h3 className="card-title">View Clients</h3>
                                    </div>
                                    <div className="card-body table-responsive p-0">
                                        <table className="table table-hover text-nowrap">
                                            <tbody>
                                                <tr>
                                                    <th>Name</th>
                                                    <td>{selectedClientData.clientName}</td>
                                                </tr>
                                                <tr>
                                                    <th>Place</th>
                                                    <td>{selectedClientData.place}</td>
                                                </tr>
                                                <tr>
                                                    <th>Project</th>
                                                    <td>{selectedClientProject.map(project => <ProjectLink project={project} />)}</td>
                                                </tr>
                                                <tr>
                                                    <th>Email</th>
                                                    <td>{selectedClientData.email}</td>
                                                </tr>
                                                <tr>
                                                    <th>Addition Information</th>
                                                    <td>{selectedClientData.additionalInformation}</td>
                                                </tr>
                                                <tr>
                                                    <th>Status</th>
                                                    <td>{selectedClientData.status ?

                                                        <span className="badge badge-success">Active</span> : <span className="badge badge-warning">Inactive</span>}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default ViewClient;